﻿import { createElement } from "./_dom";
import { printDocument } from "./docPrint";

function openDocument(url) {
	// if there is a document to download, do it
	if (url) {
		var p = 0, n = url.indexOf("?");
		if (n >= 0) {
			n++;
			var qs = new URLSearchParams(url.substring(n));
			p = qs.get("print") == "1";
			if (p) {
				qs.delete("print");
				qs.delete("back");
			}
			url = url.substring(0, n) + qs.toString();
		}
		if (p) {
			printDocument(url);
		} else if (/iP(ad|od|hone)/.test(navigator.userAgent)) {
			if (document.readyState != "complete") {
				window.addEventListener("load", () => location.assign(url));
			} else {
				location.assign(url);
			}
		} else {
			// create downloader frame
			document.body.append(createElement("iframe", { id: "td-downloader", class: "v3-downloader-frame invisible", src: url }));
		}
	}
}

export { openDocument };